import axios from "@/plugins/axios";

export default {
    actions: {
        fetchCheckUpProgressStatus(context) {
            return new Promise(((resolve, reject) => {
                axios
                    .get('/devices')
                    .then(response => {
                        context.commit('updateProgressStatus', response.data)
                        resolve()
                    })
                    .catch(() => {
                        reject()
                    })
            }))
        },
    },
    mutations: {
        updateProgressStatus(state, data) {
            state.scale = data
        },
    },
    state: {
        scale: false,
    },
    getters: {
        getCheckUpProgressStatus(state) {
            return state.scale
        }
    }
}
